(() => {
  const initArticle = (root) => {
    if (!root || root.dataset.articleSeoReady === 'true') return;

    const content = root.querySelector('[data-article-content]');
    const toc = root.querySelector('[data-article-toc]');
    const list = root.querySelector('[data-article-toc-list]');
    const toggle = root.querySelector('[data-article-toc-toggle]');

    if (!content || !toc || !list || !toggle) return;

    const selector = root.dataset.tocLevels === 'h2' ? 'h2' : 'h2, h3';
    const headings = [...content.querySelectorAll(selector)].filter((heading) => heading.textContent.trim());
    const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const baseId = heading.textContent
          .normalize('NFKC')
          .toLowerCase()
          .trim()
          .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
          .replace(/^-+|-+$/g, '') || `section-${index + 1}`;
        let id = `article-${baseId}`;
        let suffix = 2;

        while (usedIds.has(id)) {
          id = `article-${baseId}-${suffix}`;
          suffix += 1;
        }

        heading.id = id;
        usedIds.add(id);
      }

      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.classList.add('is-subheading');

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    if (headings.length < 2) {
      toc.hidden = true;
      root.dataset.articleSeoReady = 'true';
      return;
    }

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      list.hidden = expanded;
    });

    root.dataset.articleSeoReady = 'true';
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-article-seo]').forEach(initArticle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
